export enum ItemTypeEnum {
    MODULE = 'module',
    PRODUCT = 'product',
}
